import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { 
    Chart as ChartJS, CategoryScale, LinearScale, BarElement, 
    Title, Tooltip, Legend, ArcElement, PointElement, LineElement 
} from 'chart.js';
import { FaArrowLeft, FaChartLine, FaCarSide, FaUtensils, FaTrophy, FaDollarSign, FaChartBar } from 'react-icons/fa';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement);

export default function Reportes({ goBack }) {
    const [sucursalId, setSucursalId] = useState(1);
    const [dataVentas, setDataVentas] = useState(null);
    const [dataRentabilidad, setDataRentabilidad] = useState(null);
    const [loading, setLoading] = useState(false);

    const isAlquilacar = parseInt(sucursalId) === 4;

    useEffect(() => { fetchData(); }, [sucursalId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            if (isAlquilacar) {
                const res = await axios.get('https://api.alquilacarbolivia.com/api/reportes/rentabilidad');
                setDataRentabilidad({
                    labels: res.data.map(d => d.modelo),
                    datasets: [
                        { 
                            label: 'Ingresos Totales (Renta + Extras)', 
                            data: res.data.map(d => d.ingresos), 
                            backgroundColor: 'rgba(25, 135, 84, 0.8)',
                            borderColor: 'rgba(25, 135, 84, 1)',
                            borderWidth: 2
                        },
                        { 
                            label: 'Gastos (Taller/Egresos)', 
                            data: res.data.map(d => d.gastos), 
                            backgroundColor: 'rgba(220, 53, 69, 0.8)',
                            borderColor: 'rgba(220, 53, 69, 1)',
                            borderWidth: 2
                        }
                    ]
                });
            } else {
                const resTop = await axios.get(`https://api.alquilacarbolivia.com/api/reportes/top/${sucursalId}`);
                setDataVentas({
                    labels: resTop.data.map(d => d.nombre),
                    datasets: [{
                        label: 'Unidades Vendidas',
                        data: resTop.data.map(d => d.vendidos),
                        backgroundColor: [
                            'rgba(13, 110, 253, 0.8)',
                            'rgba(255, 193, 7, 0.8)',
                            'rgba(220, 53, 69, 0.8)',
                            'rgba(25, 135, 84, 0.8)',
                            'rgba(102, 16, 242, 0.8)'
                        ],
                        borderColor: [
                            'rgba(13, 110, 253, 1)',
                            'rgba(255, 193, 7, 1)',
                            'rgba(220, 53, 69, 1)',
                            'rgba(25, 135, 84, 1)',
                            'rgba(102, 16, 242, 1)'
                        ],
                        borderWidth: 2
                    }]
                });
            }
        } catch (error) { 
            console.error(error); 
        } finally {
            setLoading(false);
        }
    };

    const sucursales = [
        { value: "1", label: "COMO EN CASA", icon: <FaUtensils />, color: "#0d6efd" },
        { value: "2", label: "YUM YUM 1", icon: <FaUtensils />, color: "#198754" },
        { value: "3", label: "YUM YUM 2", icon: <FaUtensils />, color: "#ffc107" },
        { value: "4", label: "ALQUILACAR", icon: <FaCarSide />, color: "#dc3545" }
    ];

    const currentSucursal = sucursales.find(s => s.value === sucursalId);

    return (
        <div className="min-vh-100" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
            <div className="container-fluid p-4">
                {/* Header */}
                <div className="card shadow-lg border-0 mb-4" style={{ borderRadius: '15px' }}>
                    <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <div 
                                    className="d-flex align-items-center justify-content-center me-3" 
                                    style={{
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '15px',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: 'white'
                                    }}
                                >
                                    <FaChartLine size={28} />
                                </div>
                                <div>
                                    <h2 className="fw-bold mb-0" style={{ color: '#2d3748' }}>
                                        Analítica de Negocio
                                    </h2>
                                    <p className="text-muted mb-0 small">Panel de reportes y estadísticas</p>
                                </div>
                            </div>
                            <button 
                                className="btn btn-lg shadow-sm" 
                                onClick={goBack}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    border: 'none',
                                    color: 'white',
                                    borderRadius: '10px',
                                    padding: '12px 30px',
                                    fontWeight: 'bold',
                                    transition: 'transform 0.2s'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                <FaArrowLeft className="me-2"/> VOLVER
                            </button>
                        </div>
                    </div>
                </div>

                {/* Selector de Sucursal */}
                <div className="row mb-4">
                    <div className="col-lg-6">
                        <div className="card shadow-lg border-0" style={{ borderRadius: '15px' }}>
                            <div className="card-body p-4">
                                <label className="fw-bold mb-3 d-flex align-items-center" style={{ color: '#2d3748', fontSize: '16px' }}>
                                    <FaChartBar className="me-2" style={{ color: currentSucursal?.color }} />
                                    Seleccionar Unidad de Negocio
                                </label>
                                <select 
                                    className="form-select form-select-lg shadow-sm" 
                                    value={sucursalId} 
                                    onChange={e => setSucursalId(e.target.value)}
                                    style={{
                                        borderRadius: '10px',
                                        border: `2px solid ${currentSucursal?.color}`,
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#2d3748',
                                        padding: '15px'
                                    }}
                                >
                                    {sucursales.map(suc => (
                                        <option key={suc.value} value={suc.value}>
                                            {suc.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Loading State */}
                {loading && (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                            <span className="visually-hidden">Cargando...</span>
                        </div>
                        <p className="mt-3 text-muted fw-bold">Cargando datos...</p>
                    </div>
                )}

                {/* Gráficos */}
                {!loading && (
                    <>
                        {isAlquilacar ? (
                            <div className="row">
                                <div className="col-12">
                                    <div className="card shadow-lg border-0" style={{ borderRadius: '15px' }}>
                                        <div className="card-body p-4">
                                            <div className="d-flex align-items-center mb-4">
                                                <div 
                                                    className="d-flex align-items-center justify-content-center me-3"
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        borderRadius: '12px',
                                                        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                                        color: 'white'
                                                    }}
                                                >
                                                    <FaCarSide size={24} />
                                                </div>
                                                <div>
                                                    <h4 className="fw-bold mb-0" style={{ color: '#2d3748' }}>
                                                        Rentabilidad de la Flota
                                                    </h4>
                                                    <p className="text-muted mb-0 small">Análisis de ingresos vs gastos por vehículo</p>
                                                </div>
                                            </div>
                                            <div style={{ height: '450px', position: 'relative' }}>
                                                {dataRentabilidad && (
                                                    <Bar 
                                                        data={dataRentabilidad} 
                                                        options={{ 
                                                            maintainAspectRatio: false,
                                                            responsive: true,
                                                            plugins: {
                                                                legend: {
                                                                    position: 'top',
                                                                    labels: {
                                                                        font: { size: 14, weight: 'bold' },
                                                                        padding: 20
                                                                    }
                                                                },
                                                                tooltip: {
                                                                    backgroundColor: 'rgba(0,0,0,0.8)',
                                                                    padding: 12,
                                                                    titleFont: { size: 14, weight: 'bold' },
                                                                    bodyFont: { size: 13 }
                                                                }
                                                            },
                                                            scales: {
                                                                y: {
                                                                    beginAtZero: true,
                                                                    grid: { color: 'rgba(0,0,0,0.05)' },
                                                                    ticks: { font: { size: 12 } }
                                                                },
                                                                x: {
                                                                    grid: { display: false },
                                                                    ticks: { font: { size: 12, weight: 'bold' } }
                                                                }
                                                            }
                                                        }} 
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="row g-4">
                                <div className="col-lg-8">
                                    <div className="card shadow-lg border-0 h-100" style={{ borderRadius: '15px' }}>
                                        <div className="card-body p-4">
                                            <div className="d-flex align-items-center mb-4">
                                                <div 
                                                    className="d-flex align-items-center justify-content-center me-3"
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        borderRadius: '12px',
                                                        background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                                                        color: 'white'
                                                    }}
                                                >
                                                    <FaTrophy size={24} />
                                                </div>
                                                <div>
                                                    <h4 className="fw-bold mb-0" style={{ color: '#2d3748' }}>
                                                        Top 5 Productos Estrella
                                                    </h4>
                                                    <p className="text-muted mb-0 small">Productos más vendidos del período</p>
                                                </div>
                                            </div>
                                            <div style={{ height: '400px', position: 'relative' }}>
                                                {dataVentas && (
                                                    <Doughnut 
                                                        data={dataVentas} 
                                                        options={{ 
                                                            maintainAspectRatio: false,
                                                            responsive: true,
                                                            plugins: {
                                                                legend: {
                                                                    position: 'right',
                                                                    labels: {
                                                                        font: { size: 13, weight: 'bold' },
                                                                        padding: 15,
                                                                        usePointStyle: true,
                                                                        pointStyle: 'circle'
                                                                    }
                                                                },
                                                                tooltip: {
                                                                    backgroundColor: 'rgba(0,0,0,0.8)',
                                                                    padding: 12,
                                                                    titleFont: { size: 14, weight: 'bold' },
                                                                    bodyFont: { size: 13 }
                                                                }
                                                            }
                                                        }} 
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4">
                                    <div className="card shadow-lg border-0 h-100" style={{ borderRadius: '15px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                                        <div className="card-body p-4 text-white">
                                            <div className="d-flex align-items-center mb-4">
                                                <FaDollarSign size={32} className="me-3" />
                                                <h5 className="fw-bold mb-0">Resumen Ejecutivo</h5>
                                            </div>
                                            <div className="mt-4">
                                                <div className="mb-4 pb-3 border-bottom border-white border-opacity-25">
                                                    <p className="small mb-1 opacity-75">Unidad Seleccionada</p>
                                                    <h4 className="fw-bold mb-0">{currentSucursal?.label}</h4>
                                                </div>
                                                <div className="mb-4">
                                                    <p className="small mb-1 opacity-75">Total de Productos</p>
                                                    <h4 className="fw-bold mb-0">
                                                        {dataVentas?.labels.length || 0}
                                                    </h4>
                                                </div>
                                                <div className="alert alert-light mt-4">
                                                    <small className="text-dark">
                                                        <strong>💡 Tip:</strong> Selecciona diferentes unidades para comparar su desempeño
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}